import { orgSelectors } from 'ducks/orgs'
import { isEqual } from 'lodash'
import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import type { FactoryHookType } from '../type'
import maybeCreateDistributorFilterNode from './DistributorFilterNodeFactory'

const useDistributorFilterNode: FactoryHookType = ({ RendererComponent, options }) => {
  const enabledDistributors = useSelector(orgSelectors.getEnabledHardwareSuppliers)
  const [memorizedDistributors, setMemorizedDistributors] = useState(enabledDistributors)
  const selectedDistributor = useSelector(orgSelectors.getSelectedHardwareSupplier)

  useEffect(() => {
    if (!isEqual(enabledDistributors, memorizedDistributors)) {
      setMemorizedDistributors(enabledDistributors)
    }
  }, [memorizedDistributors, enabledDistributors])

  return useMemo(() => {
    return maybeCreateDistributorFilterNode({
      selectedDistributor,
      enabledDistributors: memorizedDistributors, // memorizedDistributors is used here avoid re-mounting the component
      RendererComponent,
    })
  }, [selectedDistributor, memorizedDistributors, RendererComponent])
}

export default useDistributorFilterNode
